// Los procesadores opcionales permiten consumir contratos específicos sin
// modificar el tratamiento histórico de las respuestas y errores de Citrus.
export const buscar = (url, cuerpo, opciones) => {
    return new Promise(function (resolve, reject) {
        // eslint-disable-next-line no-undef
         Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
            if (opciones && opciones.procesarRespuesta) {
                try {
                    resolve(opciones.procesarRespuesta(respuesta));
                } catch (error) {
                    reject(error);
                }
                return;
            }
            // eslint-disable-next-line no-undef
            var datos = $.parseJSON(respuesta.d);
            if (
                datos &&
                datos["Mensaje"] !== undefined &&
                datos["Detalle"] !== undefined &&
                datos["Interno"] !== undefined
            ) {
                reject(datos);
            }
            resolve(datos);
        }, opciones && opciones.procesarError ? function (respuesta) {
            try {
                reject(opciones.procesarError(respuesta));
            } catch (error) {
                reject(error);
            }
        } : undefined, undefined, opciones);
    });
};
